import { render, staticRenderFns } from "./RequestPdfButton.vue?vue&type=template&id=c5d257ae&"
import script from "./RequestPdfButton.vue?vue&type=script&lang=js&"
export * from "./RequestPdfButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports